import { c as _c } from "react/compiler-runtime";
import { throttle } from 'lodash';
import { useEffect, useState } from 'react';
const useWindowScrollPosition = t0 => {
  const $ = _c(4);
  const {
    isScrollTrackingDisabled: t1,
    time,
    previousScrollPosition
  } = t0;
  const isScrollTrackingDisabled = t1 === undefined ? false : t1;
  const [scrollPosition, setScrollPosition] = useState(previousScrollPosition ?? 0);
  let t2;
  let t3;
  if ($[0] !== isScrollTrackingDisabled || $[1] !== time) {
    t2 = () => {
      const updatePosition = throttle(() => {
        if (window) {
          setScrollPosition(_temp);
        }
      }, time, {
        leading: false
      });
      if (!isScrollTrackingDisabled) {
        window.addEventListener("scroll", updatePosition, {
          capture: false,
          passive: true
        });
      }
      return () => {
        window.removeEventListener("scroll", updatePosition);
      };
    };
    t3 = [isScrollTrackingDisabled, time];
    $[0] = isScrollTrackingDisabled;
    $[1] = time;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  return scrollPosition;
};
export default useWindowScrollPosition;
function _temp(prevState) {
  return prevState === window.scrollY ? prevState : window.scrollY;
}